module.exports = __webpack_public_path__ + "img/btnCard-4-m.a3d22f44.jpg";